export function arrayAttribute(value: unknown[] | null | undefined): unknown[] {
  return value || [];
}
